/* icon/UI 24px/Stethescope (doctor, procedure).svg: width 24px x height 24px */
export default class DlsIconStethescope extends HTMLElement {
  static define(tagName = 'dls-icon-stethescope') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" display="block" pointer-events="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M21.148 13.32a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M19.403 15.07v1.69c0 2.934-2.351 5.31-5.25 5.31-2.9 0-5.25-2.376-5.25-5.31v-1.69M6.103 5V1m5.599 2.019h3.354v6.393c0 1.149-.59 2.214-1.558 2.813L8.903 15.07l-4.596-2.845A3.307 3.307 0 012.75 9.412V3.019h3.352M11.702 5V1"/></svg>`;
  }
}
DlsIconStethescope.define();
